import asyncThunk from '@/lib/asyncThunk'
import { Account } from '@/watch-tower/out/account'

type Request = Record<never, never>

export const listAccounts = asyncThunk<Request, Account[]>({
  name: 'watch-tower/accounts/list',
  uri: '/watch-tower/accounts',
})
